module.exports = __webpack_public_path__ + "img/mellhall-h-474x356.83f9808e.jpg";